module.exports = __webpack_public_path__ + "img/Line 171.2a80a933.svg";